"use strict";

exports.__esModule = true;
exports.StyledLinkButton = exports.AnchorButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _reactRouterDom = require("react-router-dom");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// note: we need to remove the primary and small props before creating a styled-component
// otherwise the attribute will be added to the DOM and an error will occur
const StyledLinkButton = (0, _styledComponents.default)(({
  primary,
  small,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, { ...props
}))`
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    min-height: ${props => props.small || props.sm ? '40px' : '50px'};
    background-color: ${({
  theme
}) => theme.colors.button.secondary.background};
    color: ${({
  theme
}) => theme.colors.button.secondary.text};
    font-size: ${({
  theme
}) => theme.fontSizes[4]};
    font-weight: ${({
  theme
}) => theme.fontWeights.regular};
    line-height: ${({
  theme
}) => theme.lineHeights.copy};
    text-align: center;
    vertical-align: middle;
    text-decoration: none;
    padding: .7rem .9rem;
    border: 2px solid ${({
  theme
}) => theme.colors.button.secondary.border};
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
    outline: none;
    appearance: none;
    transition: color .15s ease-in-out, 
    background-color .15s ease-in-out, 
    border-color .15s ease-in-out, 
    box-shadow .15s ease-in-out;

    ${({
  theme
}) => (0, _styledComponents.css)`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.button.secondary.hover.text};
            background-color: ${theme.colors.button.secondary.hover.background};
            border-color: ${theme.colors.button.secondary.hover.border};
        }
    `}
    
    ${({
  theme,
  primary
}) => primary && (0, _styledComponents.css)`
        color: ${theme.colors.button.primary.text};
        background-color: ${theme.colors.button.primary.background};
        border-color: ${theme.colors.button.primary.border};

        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.button.primary.hover.text};
            background-color: ${theme.colors.button.primary.hover.background};
            border-color: ${theme.colors.button.primary.hover.border};
        }
    `}

    ${props => props.neutral && (0, _styledComponents.css)`
        border: none;
    `}

    ${props => (props.small || props.sm) && (0, _styledComponents.css)`
        padding: .375rem .75rem;
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.StyledLinkButton = StyledLinkButton;
const AnchorButton = _styledComponents.default.a`
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    min-height: ${props => props.small || props.sm ? '40px' : '50px'};
    background-color: ${({
  theme
}) => theme.colors.transparent};
    color: ${({
  theme
}) => theme.colors.button.secondary.text};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    vertical-align: middle;
    text-decoration: none;
    padding: .7rem .9rem;
    border: 2px solid ${({
  theme
}) => theme.colors.button.secondary.border};
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
    outline: none;
    appearance: none;
    transition: color .15s ease-in-out, 
    background-color .15s ease-in-out, 
    border-color .15s ease-in-out, 
    box-shadow .15s ease-in-out;

    ${({
  theme
}) => (0, _styledComponents.css)`
        &:hover,
        &:focus,
        &:active {
            border: 2px solid ${theme.colors.button.secondary.border};
        }
    `}

    ${({
  theme,
  primary
}) => primary && (0, _styledComponents.css)`
        color: ${theme.colors.button.primary.text};
        background-color: ${theme.colors.button.primary.background};
        border-color: ${theme.colors.button.primary.border};

        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.button.primary.hover.text};
            background-color: ${theme.colors.button.primary.hover.background};
            border-color: ${theme.colors.button.primary.hover.border};
        }
    `}

    ${props => props.neutral && (0, _styledComponents.css)`
        border: none;
    `}

    ${props => (props.small || props.sm) && (0, _styledComponents.css)`
        padding: .375rem .75rem;
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.AnchorButton = AnchorButton;